import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Box } from "@mui/material";

import { ActionButton, FormDialog, InputField } from "../../v3";
import { editStageValidationRules } from "../../../pages/library/stages/validation";
import { ProjectService } from "../../../services";

export const AddEditStage = ({ open, onClose, stageId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [stageDetails, setStageDetails] = useState({
    name: undefined,
    description: undefined,
  });

  useEffect(() => {
    if (open && stageId) {
      fetchData(stageId);
    } else if (open && !stageId) {
      handleClearForm();
    }
  }, [open, stageId]);

  const fetchData = async (id) => {
    try {
      const { data } = await ProjectService.getStageById(id);
      setStageDetails({
        name: data?.name || undefined,
        description: data?.description || undefined,
      });
    } catch (error) {
      toast.error("Failed to fetch stage details");
      console.error("Error fetching stage data:", error);
    }
  };

  const updateDetailsState = (e) => {
    const { name, value } = e.target;
    setStageDetails((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleClearForm = () => {
    setStageDetails({
      name: undefined,
      description: undefined,
    });
  };

  const handleCloseModal = () => {
    handleClearForm();
    setErrors({});
    onClose();
  };

  const handleSaveStage = async () => {
    setErrors({});
    const errors = editStageValidationRules(stageDetails);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    try {
      setLoading(true);
      if (stageId) await ProjectService.updateStage(stageId, stageDetails);
      else await ProjectService.createStage(stageDetails);
      toast.success(`Stage ${stageId ? "updated" : "created"} successfully`);
      onSuccess?.();
    } catch (error) {
      let errorMessage = `Error ${stageId ? "updating" : "adding"} stage`;
      const response = error?.response?.data;

      if (Array.isArray(response?.message)) {
        errorMessage = response.message.join(", ");
      } else if (typeof response?.message === "string") {
        errorMessage = response.message;
      }

      toast.error(errorMessage);
      console.error("🚀 ~ handleSaveStage ~ error:", error);
    } finally {
      setLoading(false);
      handleCloseModal();
    }
  };
  return (
    <FormDialog
      open={open}
      title={stageId ? "Edit Stage" : "Add Stage"}
      actions={
        <>
          <ActionButton buttonText="Cancel" onButtonClick={handleCloseModal} variant="outlined" />
          <ActionButton buttonText="Save" onButtonClick={handleSaveStage} disabled={loading} />
        </>
      }
    >
      <Box mt={1}>
        <Box className="fl gap-2">
          <InputField
            required
            label="Stage Name"
            name="name"
            value={stageDetails.name}
            onChange={updateDetailsState}
            error={!!errors.name}
            helperText={errors.name}
            style={{ width: "100%" }}
          />
          <InputField
            label="Description"
            name="description"
            value={stageDetails.description}
            onChange={updateDetailsState}
            error={!!errors.description}
            helperText={errors.description}
            style={{ width: "100%" }}
          />
        </Box>
      </Box>
    </FormDialog>
  );
};
